export default $(()=>{

    let $navigation = $('.section-price-sheets .announcements .navigation a');
    let $announcements = $('.section-price-sheets .announcements .announcement');

    $navigation.on('click', function(e) {
        e.preventDefault();

        let a = $(this);
        let year = a.data('year-select');
        let $yearArea = $announcements.filter('[data-year="' + year + '"]');

        $navigation.closest('div').removeClass('active');
        a.closest('div').addClass('active');
        $announcements.hide();
        $yearArea.show().find('> div').removeClass('close').addClass('open');
        $yearArea.find('.content').slideDown();
    });

    const accordions = document.querySelectorAll('[data-table-accordion]')
    accordions.forEach((parent) => {
        const parentId = parent.id
        const children = document.querySelectorAll(`[data-table-parent='${parentId}']`)
        const trigger = parent.querySelector('.priceSheet__rowTrigger')

        // close all children by default on load.
        children.forEach(child => child.style.display = 'none')

        // on click, display children
        trigger.addEventListener('click', () => {
            const icon = trigger.querySelector('i.fa')

            if ( icon.classList.contains('fa-plus-square') ) {
                icon.classList.remove('fa-plus-square')
                icon.classList.add('fa-minus-square')
            } else {
                icon.classList.remove('fa-minus-square')
                icon.classList.add('fa-plus-square')
            }

            children.forEach((child) => {
                if ( child.style.display === 'table-row' ) {
                    child.style.display = 'none'
                } else {
                    child.style.display = 'table-row'
                }
            })
        })
    })
});